import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';
import { UiButtonSize } from '../../types/ui-button-size.type';
import { UiButtonVariant } from '../../types/ui-button-variant.type';

type UiButtonType = 'button' | 'submit' | 'reset';

@Component({
  selector: 'ui-button',
  imports: [],
  templateUrl: './ui-button.component.html',
  styleUrl: './ui-button.component.scss',
  host: {
    '[class.ui-button-host-full-width]': 'fullWidth()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiButtonComponent {
  public readonly variant: InputSignal<UiButtonVariant> = input<UiButtonVariant>('primary');
  public readonly size: InputSignal<UiButtonSize> = input<UiButtonSize>('md');
  public readonly type: InputSignal<UiButtonType> = input<UiButtonType>('button');
  public readonly disabled: InputSignal<boolean> = input<boolean>(false);
  public readonly fullWidth: InputSignal<boolean> = input<boolean>(false);
  public readonly pressed: OutputEmitterRef<void> = output<void>();

  protected readonly isPrimary: Signal<boolean> = computed((): boolean => this.variant() === 'primary');
  protected readonly isSecondary: Signal<boolean> = computed((): boolean => this.variant() === 'secondary');
  protected readonly isGhost: Signal<boolean> = computed((): boolean => this.variant() === 'ghost');
  protected readonly isSmall: Signal<boolean> = computed((): boolean => this.size() === 'sm');
  protected readonly isMedium: Signal<boolean> = computed((): boolean => this.size() === 'md');
  protected readonly isLarge: Signal<boolean> = computed((): boolean => this.size() === 'lg');
  protected readonly isFullWidth: Signal<boolean> = computed((): boolean => this.fullWidth());

  protected handleClick(event: MouseEvent): void {
    if (this.disabled()) {
      event.preventDefault();
      return;
    }

    this.pressed.emit();
  }
}
